﻿import ko from "@tko/build.knockout";

const h = ko.bindingHandlers;

const dependendOptionsSymbol = Symbol("ko-dependendOptions");

const nativeOptions = h.options;

h["dependsOn"] = {};
h["dependsOnFilter"] = {};

h.options = {
	...nativeOptions,
	init(element, valueAccessor, allBindingsAccessor, ...rest) {
		if (allBindingsAccessor.has("dependsOn")) {
			element[dependendOptionsSymbol] = Array.from(element.options, option => ({
				value: option.value,
				text: option.text,
				disabled: option.disabled,
				dataset: { ...option.dataset }
			}));
		}
		return nativeOptions.init(element, valueAccessor, allBindingsAccessor, ...rest);
	},
	update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		if (!allBindingsAccessor.has("dependsOn")) {
			return nativeOptions.update(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
		}
		const dependsOn = ko.unwrap(allBindingsAccessor.get("dependsOn"));
		const dependsOnValue = ko.unwrap(viewModel[dependsOn]);
		const filterFunction = ko.unwrap(allBindingsAccessor.get("dependsOnFilter")).bind(bindingContext);
		const supplied = ko.unwrap(valueAccessor());
		const fromMarkup = supplied == null;
		const source = fromMarkup
			? element[dependendOptionsSymbol]
			: supplied;

		const filtered = source.filter(item => filterFunction(item, dependsOnValue, dependsOn));
		if (fromMarkup && element.dataset.emptyOptionsText && filtered.length === 1 && filtered[0].value === "") {
			filtered[0] = { ...filtered[0], text: element.dataset.emptyOptionsText };
		}

		let effectiveBindings = allBindingsAccessor;

		if (fromMarkup) {
			const afterRender = allBindingsAccessor.get("optionsAfterRender");
			const overrides = {
				optionsText: "text",
				optionsValue: "value",
				optionsAfterRender(option, item) {
					if (item) {
						option.disabled = item.disabled;
						Object.assign(option.dataset, item.dataset);
					}
					afterRender?.(option, item);
				}
			};

			// Forward value, valueAllowUnset, optionsCaption, etc. unchanged.
			effectiveBindings = {
				get(name) {
					return Object.hasOwn(overrides, name)
						? overrides[name]
						: allBindingsAccessor.get(name);
				},
				has(name) {
					return Object.hasOwn(overrides, name) || allBindingsAccessor.has(name);
				}
			};
		}

		return nativeOptions.update(element, () => filtered, effectiveBindings, viewModel, bindingContext);
	}
}

ko.bindingHandlers.files = {
	init: function (element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		const updateValue = (elementValue) => {
			var valueSetter = valueAccessor();
			valueSetter.splice.apply(valueSetter, [0, 100000].concat(elementValue));
		};
		updateValue([]);
		ko.utils.registerEventHandler(element, "change", function () {
			const elementValue = [...element.files].map(f => ({ name: f.name, type: f.type, size: f.size, lastModified: f.lastModified }));
			updateValue(elementValue);
		});
	},
	update: function (element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		const value = ko.unwrap(valueAccessor());
		// reset file input if null, [] or ""
		if (value == null || value.length == 0)
			element.value = "";
	}
};

const modelSymbol = Symbol("ko-model");

function getModel(form) {
	return form[modelSymbol];
}

function initKOForm(form) {
	if (form.tagName != "FORM")
		throw "not a form element";

	var model = {};

	if (ko.ext) {
		for (const [k, v] of Object.entries(ko.ext)) {
			Object.defineProperty(model, `koext_${k}`, {
				get() { return v },
				enumerable: true,
				configurable: true
			});
		}
	}

	const els = form.elements;
	for (let i = 0, l = els.length; i < l; i++) {
		const el = els[i], n = el.name;
		let v = null,
			m = false, // multiple elements?
			db = /\b(?:checked|value|textInput|files):([A-Za-z0-9_]+)/.exec(el.getAttribute("data-bind") || "");
		if (!n || !db) continue;
		db = db[1];
		if (el.tagName == "INPUT" && el.type == "file" && el.multiple)
			v = [];
		else if (el.tagName == "INPUT" && el.type == "checkbox") // for checkbox it's a true/false, unless we have many under the same name
			v = (m = (els[n].length > 1)) == true ? el.checked ? el.value : null : el.checked;
		else if (el.tagName != "INPUT" || el.type != "radio" || el.checked)
			v = el.value;
		if (model[db] == null)
			model[db] = m ? v != null ? [v] : [] : v;
		else if (Array.isArray(model[db]) && v != null)
			model[db].push(v);
		else if (v != null)
			model[db] = [model[db], v];
	}
	for (var mm in model) {
		model[mm] = Array.isArray(model[mm]) ?
			ko.observableArray(model[mm]) :
			ko.observable(model[mm]);
	}
	ko.applyBindings(model, form);
	form[modelSymbol] = model;
}

function init(context, selector = ".v3-form") {
	(context || document).querySelectorAll(selector).forEach(form => initKOForm(form));
}

export { init, getModel };